import type { SelectionCandidateState } from 'api/bcks/useAPIBCKSInvitation'

export const URL_HELPDESK =
  'https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id'

export const SELECTION_STATES_PEMBUKAAN: SelectionCandidateState[] = [
  'notInvited',
  'notInvitedGuru',
  'notInvitedKS',
  'invitation',
]

export const SELECTION_STATES_ADMINISTRASI: SelectionCandidateState[] = [
  'documentSubmission',
  'documentVerification',
  'documentVerificationFailed',
  'adminFailed',
  'adminCanceled',
  'adminFinished',
]

export const SELECTION_STATES_NAPZA_NON_REG: SelectionCandidateState[] = [
  'napzaInvitation',
  'napzaVerification',
  'napzaFailed',
  'napzaFinished',
]

export const SELECTION_STATES_SUBSTANSI: SelectionCandidateState[] = [
  'substanceInProgress',
  'substanceFailed',
]

export const SELECTION_STATES_PELATIHAN: SelectionCandidateState[] = [
  'substanceFinished',
  'diklatPending',
  'diklatInProgress',
  'diklatFailed',
  'diklatFinished',
  'diklatCertificateIssued',
]

export const SELECTION_STATES_DOKUMEN_AKHIR: SelectionCandidateState[] = [
  'napzaRegularInvitation',
  'napzaRegularVerification',
  'napzaRegularFailed',
]

export const SELECTION_STATES_HASIL_SELEKSI: SelectionCandidateState[] = [
  'napzaRegularFinished',
  'overrideFinished',
]

// Be careful changing this since this has to be ordered
export const SELECTION_STATES_ORDERED: SelectionCandidateState[] = [
  ...SELECTION_STATES_PEMBUKAAN,
  ...SELECTION_STATES_ADMINISTRASI,
  ...SELECTION_STATES_NAPZA_NON_REG,
  ...SELECTION_STATES_SUBSTANSI,
  ...SELECTION_STATES_PELATIHAN,
  ...SELECTION_STATES_DOKUMEN_AKHIR,
  ...SELECTION_STATES_HASIL_SELEKSI,
]

export const SELECTION_STATES_ORDERED_V2: SelectionCandidateState[] = [
  ...SELECTION_STATES_PEMBUKAAN,
  ...SELECTION_STATES_ADMINISTRASI,
  ...SELECTION_STATES_SUBSTANSI,
  ...SELECTION_STATES_PELATIHAN,
  ...SELECTION_STATES_NAPZA_NON_REG,
  ...SELECTION_STATES_DOKUMEN_AKHIR,
  ...SELECTION_STATES_HASIL_SELEKSI,
]

export const SELECTION_STATES_FINAL_PAGE: SelectionCandidateState[] = [
  'documentVerification',
  'documentVerificationFailed',
  'adminFinished',
  'adminFailed',
  'adminCanceled',
  'napzaInvitation',
  'napzaVerification',
  'napzaFinished',
  'napzaFailed',
  'substanceInProgress',
  'substanceFinished',
  'substanceFailed',
  'diklatInProgress',
  'diklatPending',
  'diklatFinished',
  'diklatFailed',
  'diklatCertificateIssued',
  'napzaRegularInvitation',
  'napzaRegularVerification',
  'napzaRegularFinished',
  'napzaRegularFailed',
  'pairing',
  'rejectOffer',
  'reject',
  'failed',
  'finished',
  'regularFinished',
]
